import { DrawerProps } from '@material-ui/core';
import { useCollapsibleMenuStyles } from './CollapsibleMenu.styles';
import { MenuVariant } from '../SideNavigationMenuHelpers';

export const getVariant = (collapsed: boolean, permanent: boolean) => {
    if (permanent) {
        return MenuVariant.persistent;
    }

    if (collapsed) {
        return MenuVariant.permanent;
    }

    return MenuVariant.temporary;
};

export const getModalProps = (
    collapsed: boolean,
    handleDrawerToggle: () => void,
    classes: ReturnType<typeof useCollapsibleMenuStyles>
): DrawerProps['ModalProps'] => {
    if (!collapsed) {
        return {
            keepMounted: true,
            onBackdropClick: handleDrawerToggle,
            BackdropProps: {
                classes: { root: classes.nonCollapsedBackdrop },
            },
        };
    }

    return {};
};
